interface TelemetryEvent {
  event: string;
  timestamp: string;
  data?: Record<string, any>;
}

class TelemetryService {
  private enabled: boolean = true;

  logEvent(eventName: string, data?: Record<string, any>): void {
    if (!this.enabled) return;

    const event: TelemetryEvent = {
      event: eventName,
      timestamp: new Date().toISOString(),
      data,
    };

    console.log('[TELEMETRY]', JSON.stringify(event));

    if (typeof window !== 'undefined' && (window as any).analytics) {
      try {
        (window as any).analytics.track(eventName, data);
      } catch (error) {
        console.error('[TELEMETRY] Failed to send to analytics:', error);
      }
    }
  }

  logRolesSaveClicked(employeeId: number, role: string): void {
    this.logEvent('roles_save_clicked', { employeeId, role });
  }

  logRolesSaveSucceeded(employeeId: number, role: string): void {
    this.logEvent('roles_save_succeeded', { employeeId, role });
  }

  logRolesSaveFailed(employeeId: number, role: string, errorCode?: string, statusCode?: number): void {
    this.logEvent('roles_save_failed', { employeeId, role, errorCode, statusCode });
  }

  disable(): void {
    this.enabled = false;
  }

  enable(): void {
    this.enabled = true;
  }
}

export default new TelemetryService();
